var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37087 14.7019L2.54661 10.5869C2.58162 10.4643 2.6473 10.3527 2.73742 10.2626L9.4 3.6L11 2C12.1046 0.89543 13.8954 0.89543 15 2C16.1046 3.10457 16.1046 4.89543 15 6L13.4 7.6L6.73742 14.2626C6.6473 14.3527 6.53569 14.4184 6.41313 14.4534L2.29806 15.6291C1.73229 15.7908 1.20923 15.2677 1.37087 14.7019Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 3.6L2.73742 10.2626C2.6473 10.3527 2.58162 10.4643 2.54661 10.5869L1.37087 14.7019C1.20923 15.2677 1.73229 15.7908 2.29806 15.6291L6.41313 14.4534C6.53569 14.4184 6.6473 14.3527 6.73742 14.2626L13.4 7.6M9.4 3.6L11 2C12.1046 0.89543 13.8954 0.89543 15 2V2C16.1046 3.10457 16.1046 4.89543 15 6L13.4 7.6M9.4 3.6L13.4 7.6",
    stroke: "#2B323B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.0bcfafd49fbdc9a0a87e7849c700d4ff.svg";
export { ForwardRef as ReactComponent };